




























































import Vue from "vue";
import StatusCard from "./StatusCard.vue";
import StatusLine from "./StatusLine.vue";

const card = [
  {
    title: "集群CPU状态(Core)",
    val: "cluster_cpu_usage",
    sum: "cluster_total_cpu",
    valLabel: "已用CPU: ",
    sumLabel: "全部CPU: ",
    color: "#4CAF50"
  },
  {
    title: "集群内存状态(Gib)",
    val: "cluster_pod_memory_usage",
    sum: "cluster_total_memory",
    valLabel: "已用内存: ",
    sumLabel: "全部内存: ",
    color: "#4CAF50",
    format: (value: string) =>
      (parseFloat(value) / 1024 / 1024 / 1024).toFixed(2).replace(".00", "")
  },
  {
    title: "集群节点状态",
    val: "cluster_node_online",
    sum: "cluster_node_total",
    valLabel: "节点在线数: ",
    sumLabel: "全部节点: ",
    color: "#4CAF50"
  }
];
const monitor = [
  {
    title: "CPU使用情况(%)",
    type: "cluster_cpu_utilisation"
  },
  { title: "内存使用情况(%)", type: "cluster_memory_utilisation" },
  { title: "集群定时任务", type: "cluster_cronjob_count" },
  { title: "集群无状态负载", type: "cluster_deployment_count" },
  { title: "集群有状态负载", type: "cluster_statefulset_count" },
  { title: "集群服务数", type: "cluster_service_count" },
  { title: "集群命名空间数", type: "cluster_namespace_count" },
  { title: "集群存储卷声明", type: "cluster_pvc_count" },
  { title: "集群容器组数", type: "cluster_pod_count" },
  { title: "集群容器数", type: "cluster_container_count" }
];
export default Vue.extend({
  name: "Overview",
  components: {
    StatusCard,
    StatusLine
  },
  data() {
    return {
      step: "1m",
      stepOption: [
        { label: "1分钟", value: "1m" },
        { label: "10分钟", value: "10m" },
        { label: "30分钟", value: "30m" },
        { label: "1小时", value: "1h" },
        { label: "1天", value: "24h" }
      ],
      dateRange: [
        new Date(new Date().getTime() - 2 * 60 * 60 * 1000),
        new Date()
      ],
      monitor,
      card
    };
  },
  mounted() {
    this.getData();
    this.getCard();
  },
  methods: {
    getCard() {
      (this.$refs.card as Vue[]).forEach(card => {
        (card as any).getData();
      });
    },
    getData() {
      this.$nextTick(() => {
        (this.$refs.line as Vue[]).forEach(line => {
          (line as any).getData();
        });
      });
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "10m":
          this.$set(this, "dateRange", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "dateRange", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "dateRange", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "dateRange", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
